import { type RequestStatus } from '@/microfrontends/filters/shared/types/RequestStatus';

import { useReduxSelector } from '../../../external/hooks';

import { searchMetaSelector } from './root';

export function useSearchMetaStatusSelector(): RequestStatus {
  const meta = useReduxSelector(searchMetaSelector);

  return meta.status;
}

export function useIsSearchMetaLoadingSelector(): boolean {
  const status = useSearchMetaStatusSelector();

  return status === 'loading';
}
